import axios from 'axios';
import END_POINT from '../config/endpoints.constants';
import { CreditLog, UUID } from '../types';

export interface GetAllCreditLogRequestOption {
    startDate?: string;
    endDate?: string;
    limit: number;
    offset: number;
    number?: string;
    groupId?: UUID;
}

export interface GetAllCreditLogResult {
    creditLogs?: CreditLog[];
    totalCount?: number;
    error: any;
}

interface GetAllCreditLogResponse {
    data: {
        objects: CreditLog[];
        totalCount: number;
    };
}

export interface GetDefaultCreditLogsRequestPayload {
    offset: number;
    limit: number;
    startDate?: string;
    endDate?: string;
}

export async function getAllCreditLog(option: GetAllCreditLogRequestOption) {
    const result = {} as GetAllCreditLogResult;
    try {
        const { data: responseData } = await axios.post<GetAllCreditLogResponse>(
            END_POINT.GET_CREDIT_LOGS,
            option,
        );
        if (responseData?.data) {
            const { objects, totalCount } = responseData.data;
            result.creditLogs = objects;
            result.totalCount = totalCount;
        }
    } catch (error) {
        result.error = error;
    }
    return result;
}
